import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { ChromePicker } from 'react-color';
import { FormFeedback } from 'reactstrap';

import { Popover } from 'components';
import { getFieldError } from 'infrastructure/form';
import './ColorPicker.scss';

class ChromeColorPickerField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  };

  static defaultProps = {
    value: '',
  };

  constructor(props) {
    super();
    this.state = {
      color: props.value || '',
    };
    this.colorPickerContainer = React.createRef();
  }

  handleTouchStart = () => {
    if (this.colorPickerContainer.current) {
      this.colorPickerContainer.current.addEventListener(
        'touchmove',
        event => {
          event.preventDefault();
        },
        false
      );
    }
  };

  handleTouchEnd = () => {
    if (this.colorPickerContainer.current) {
      this.colorPickerContainer.current.removeEventListener('touchmove');
    }
  };

  handleChange = color => {
    const { onChange } = this.props;
    this.setState({ color: color.hex });
    onChange(color);
  };

  render() {
    const { color } = this.state;
    const { name, value } = this.props;
    const actualColor = color || value;
    return (
      <div className="color-picker">
        <Popover
          buttonClassname="btn color-picker__button"
          id={name}
          trigger={
            <React.Fragment>
              <span className="color-picker__color">{actualColor}</span>
              <div
                className="color-picker__color-view"
                style={{ backgroundColor: actualColor }}
              />
            </React.Fragment>
          }
        >
          <div
            onTouchStart={this.handleTouchStart}
            onTouchEnd={this.handleTouchEnd}
            ref={this.colorPickerContainer}
          >
            <ChromePicker
              color={color}
              onChange={this.handleChange}
              disableAlpha
            />
          </div>
        </Popover>
      </div>
    );
  }
}

const renderChromeColorPickerField = props => {
  const { input, field, form, hasAttemptedSubmit } = props;
  const { touched = {} } = form;
  const isTouched = getIn(touched, field.name);
  const error = getFieldError(form, field.name);

  return (
    <div className="form__form-group-input-wrap--error-below">
      <ChromeColorPickerField {...input} />
      {(isTouched || hasAttemptedSubmit) && error && (
        <FormFeedback className="validation form__form-group-error" tag="small">
          {error}
        </FormFeedback>
      )}
    </div>
  );
};

renderChromeColorPickerField.propTypes = {
  input: PropTypes.shape().isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderChromeColorPickerField.defaultProps = {
  meta: null,
};

export default renderChromeColorPickerField;
